// extracted by mini-css-extract-plugin
export default {"container":"cea-z","innerContainer":"dea-z","multipleLines":"eea-z","heading":"fea-z","content":"gea-z","linkColor":"hea-z"};